import { render, staticRenderFns } from "./404.vue?vue&type=template&id=48f4a31c"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f4a31c')) {
      api.createRecord('48f4a31c', component.options)
    } else {
      api.reload('48f4a31c', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=48f4a31c", function () {
      api.rerender('48f4a31c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/error-page/404.vue"
export default component.exports